module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//light.png?v=4738bbb8";